import {FC, useState} from 'react';
import CompanyDetails from './CompanyDetails';
import {CompanyDetailsFormFields, UserDetailsFormFields} from './types';
import UserDetails from './UserDetails';

type CreatePartialFormData = Partial<UserDetailsFormFields> &
    Partial<CompanyDetailsFormFields>;

const Create: FC = () => {
    const [page, setPage] = useState(1);
    const [data, setData] = useState<CreatePartialFormData>({
        companySize: 'organization',
    });

    if (page === 2) {
        return (
            <CompanyDetails
                onBack={() => setPage(1)}
                onUpdate={(formData) =>
                    setData((prev) => ({
                        ...prev,
                        ...formData,
                    }))
                }
                prefillData={data}
            />
        );
    }

    return (
        <UserDetails
            onSuccess={() => setPage(2)}
            onUpdate={(formData) =>
                setData((prev) => ({
                    ...prev,
                    ...formData,
                }))
            }
            prefillData={data}
        />
    );
};

export default Create;
